import React from 'react';

import { I18n } from '@aws-amplify/core';

import { ModalBorder } from '@/components/ui';
import { CustomButton } from '@/components/ui/Buttons/CustomButton/styles';
import { JDS_D86_CURRENT_REVISION } from '@/utils/customReport';

import * as S from './styles';

const CONFIRM_TEXT =
	'By deconsolidating, the report will be updated to revision JDS-D86 04/2025. Do you want to proceed?';
const MODAL_WIDTH = 420;

interface DesconsolidateModalProps {
	isLoading: boolean;
	isModalOpen: boolean;
	onConfirm: () => void;
	setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export function DesconsolidateModal(props: Readonly<DesconsolidateModalProps>): JSX.Element {
	const { isLoading, isModalOpen, onConfirm, setIsModalOpen } = props;

	const confirmText = I18n.get(CONFIRM_TEXT);

	const [confirmBefore, confirmAfter] = confirmText.split(JDS_D86_CURRENT_REVISION);

	function handleCancel(): void {
		setIsModalOpen(false);
	}

	function handleConfirm(): void {
		onConfirm();
	}

	return (
		<ModalBorder
			$borderRadius="1.5rem"
			width={MODAL_WIDTH}
			open={isModalOpen}
			footer={false}
			onCancel={handleCancel}
		>
			<S.Content>
				<S.ModalTitle level={4}>{I18n.get('Deconsolidate report')}</S.ModalTitle>

				<S.Body>
					{confirmBefore}
					<strong>{JDS_D86_CURRENT_REVISION}</strong>
					{confirmAfter}
				</S.Body>

				<S.Footer>
					<CustomButton size="large" onClick={handleCancel}>
						{I18n.get('No')}
					</CustomButton>

					<CustomButton size="large" type="primary" onClick={handleConfirm} loading={isLoading}>
						{I18n.get('Yes')}
					</CustomButton>
				</S.Footer>
			</S.Content>
		</ModalBorder>
	);
}
